import { NbaApp } from './schedule-picker';
import { mapDictionaryToArray, rankSort } from '../shared/helpers';

(window as any).SchedulePicker = (window as any).SchedulePicker ?? {};
(window as any).SchedulePicker.App = { mapDictionaryToArray, RankSort: rankSort };

// The NbaApp constructor is self-bootstrapping: it fires an AJAX request and
// calls ko.applyBindings(self, document.getElementById('content')) from within
// its own success callback once data has loaded.  We only need to instantiate it.
document.addEventListener('DOMContentLoaded', () => {
  const app = new NbaApp();
  // Expose instance methods used in KO view bindings
  (window as any).SchedulePicker.App.convertPrimeTimeToShortString = app.convertPrimeTimeToShortString.bind(app);
  (window as any).SchedulePicker.App.convertPrimeTimeToString = app.convertPrimeTimeToString.bind(app);
  (window as any).SchedulePicker.App.convertPrimeTimeAndDateToString = app.convertPrimeTimeAndDateToString.bind(app);
  (window as any).__pp_debug = app;
});
